import { useMemo } from 'react'
import {
  Box,
  Table,
  TableColumnDefinition,
  Stack,
  Hidden,
  Skeleton
} from '@machobear/design-system'
import Card from './Card'

const DesktopSkeleton = ({ id }: { id: string }) => {
  const columnDefinition: TableColumnDefinition = useMemo(
    () => [
      {
        accessor: 'title',
        Header: <Skeleton.Shape height={24} width={120} />,
        gridWidth: 'fill-available',
        disableSortBy: true,
        Cell: () => <Skeleton.Shape width={160} height={32} />
      },
      {
        accessor: 'credits',
        Header: <Skeleton.Shape height={24} width={100} />,
        gridWidth: 'fill-available',
        disableSortBy: true,
        Cell: () => <Skeleton.Shape width={20} height={32} />
      },
      {
        accessor: 'manage',
        gridWidth: 'fill-available',
        disableSortBy: true,
        Cell: () => <Skeleton.Shape height={32} />
      },
      {
        accessor: 'button',
        gridWidth: 'fill-available',
        disableSortBy: true,
        Cell: () => <Skeleton.Shape height={32} />
      }
    ],
    []
  )

  const emptyTableData = [<span />, <span />]

  return (
    <Box data-testid={`skeleton-${id}`}>
      <Hidden below="desktop">
        <Stack align="left" space="xsmall">
          <Box width="full" maxWidth="large">
            <Table columns={columnDefinition} data={emptyTableData} />
          </Box>
        </Stack>
      </Hidden>
      <Hidden above="tablet">
        <Stack align="left" space="xsmall">
          <Stack align="center" space="xsmall">
            {emptyTableData?.map((_, index) => (
              <Card key={`skeleton-mobile-card-mp-${index}`} />
            ))}
          </Stack>
        </Stack>
      </Hidden>
    </Box>
  )
}

export default DesktopSkeleton
